import {
    FASTSHIFT_ROLL_UP_STATUS,
    FastshiftRollUpStatus
} from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { messages } from "./messages";

/**
 * Returns the lozenge appearance color for a rollup status.
 * Falls back to 'default' for unknown statuses.
 *
 * @param status - The rollup status
 * @returns The lozenge appearance color
 */
export const getStatusColor = (status: FastshiftRollUpStatus) => {
    switch (status) {
        case FASTSHIFT_ROLL_UP_STATUS.COMPLETE:
        case FASTSHIFT_ROLL_UP_STATUS.ON_TRACK:
            return "success";
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_ATLASSIAN_OWNED:
            return "inprogress";
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_PARTNER_OWNED:
            return "new";
        case FASTSHIFT_ROLL_UP_STATUS.NEEDS_CUSTOMER_ATTENTION:
            return "moved";
        case FASTSHIFT_ROLL_UP_STATUS.TO_DO:
        default:
            return "default";
    }
};

/**
 * Returns the display message for a rollup status.
 * For unknown statuses, returns a fallback message instead of null to prevent UI crashes.
 *
 * @param status - The rollup status
 * @returns The internationalized message for the status, or a fallback for unknown statuses
 */
export const getStatusText = (status: FastshiftRollUpStatus) => {
    switch (status) {
        case FASTSHIFT_ROLL_UP_STATUS.COMPLETE:
            return messages.migrationTicketsListStatusComplete;
        case FASTSHIFT_ROLL_UP_STATUS.ON_TRACK:
            return messages.migrationTicketsListStatusOnTrack;
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_ATLASSIAN_OWNED:
            return messages.migrationTicketsListStatusAtRiskAtlassianOwned;
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_PARTNER_OWNED:
            return messages.migrationTicketsListStatusAtRiskPartnerOwned;
        case FASTSHIFT_ROLL_UP_STATUS.NEEDS_CUSTOMER_ATTENTION:
            return messages.migrationTicketsListStatusNeedsCustomerAttention;
        case FASTSHIFT_ROLL_UP_STATUS.TO_DO:
            return messages.migrationTicketsListStatusToDo;
        default:
            return messages.migrationTicketsListStatusUnknown;
    }
};
